import { render } from "./TemplateSection.vue?vue&type=template&id=5a382171&scoped=true"
import script from "./TemplateSection.vue?vue&type=script&lang=js"
export * from "./TemplateSection.vue?vue&type=script&lang=js"

import "./TemplateSection.vue?vue&type=style&index=0&id=5a382171&lang=scss&scoped=true"

import exportComponent from "/var/www/testback/Frontend/sdd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a382171"]])

export default __exports__